import { ListItemAvatar as MuiListItemAvatar, ListItemAvatarProps as MuiListItemAvatarProps } from '@mui/material';
import * as React from 'react';

export interface ListItemAvatarProps extends MuiListItemAvatarProps {}

export const ListItemAvatar = (props: ListItemAvatarProps) => {
  return <MuiListItemAvatar {...props} />;
};
